import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=0658fb87&scoped=true&"
import script from "./Bill.vue?vue&type=script&lang=js&"
export * from "./Bill.vue?vue&type=script&lang=js&"
import style0 from "./Bill.vue?vue&type=style&index=0&id=0658fb87&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658fb87",
  null
  
)

export default component.exports